/**
 * Shell font (sidebar, phone app bar, account menu): Inter. A CSS variable
 * defined in `index.css`, loaded as a web font in `index.html`.
 */
export const APP_FONT_FAMILY_VAR = 'var(--app-font-family)';

/**
 * Content-area font (Readex Pro, a bilingual Latin/Arabic face, so the Arabic
 * help articles render with the same type). Applied only by the content theme
 * and `ContentSurface` — the sidebar and shell keep Inter.
 */
export const CONTENT_FONT_FAMILY_VAR = 'var(--content-font-family)';
